module.exports = __webpack_public_path__ + "static/media/cardCover.599c12dc.jpg";